import { FC, useState } from "react"
import { useTranslation } from "react-i18next"

import Checkbox from "components/Checkbox/Checkbox"
import { Flex } from "components/Flex"
import Text from "components/Text/Text"
import { Article } from "models/Article"
import toastMessages from "stores/toastMessages"
import ArticleService from "services/ArticleService"
import ConfirmModal from "components/ConfirmModal/ConfirmModal"


interface IArticleInspectionSettingsProps {
    onClose: () => void,
    article: Article,
    onUpdated: () => void,
}
const ArticleInspectionSettings: FC<IArticleInspectionSettingsProps> = ({ onClose, article, onUpdated }) => {
    const { t } = useTranslation()
    const [inspectionRequired, setInspectionRequired] = useState(article.inspectionRequired)

    const [isLoading, setIsLoading] = useState(false)

    const handleSave = async () => {
        const link = article.linkUpdateInspectionSettings
        setIsLoading(true)
        if (!link) return
        try {
            await ArticleService.updateArticleInspectionSettings(link, { inspectionRequired })
            onClose()
            onUpdated()
        } catch (e) {
            toastMessages.showSystemError()
        }

        setIsLoading(false)
    }
    return (
        <ConfirmModal
            title={t("article.editInspectionSettings")}
            onClose={onClose}
            onConfirm={handleSave}
            width="586px"
            isBusy={isLoading}
            confirmButtonLabel={t("common.save")}
        >
            <Flex flow='column' className="mt-2 pl-2" >
                <Checkbox
                    onChange={() => setInspectionRequired(prev => !prev)}
                    disabled={isLoading}
                    label={
                        <Text
                            className="color-grey-600">
                            {t("article.inspectionRequired")}
                        </Text>} checked={inspectionRequired}
                />
            </Flex>
        </ConfirmModal>
    )
}

export default ArticleInspectionSettings
